/* NUQA — scripts propios (sin librerías) */
(function () {
  // Cada sección enlaza este archivo; nos aseguramos de ejecutarlo una sola vez.
  if (window.__nqInit) return;
  window.__nqInit = true;

  function initReveal() {
    var els = document.querySelectorAll('.nq-reveal');
    if (!els.length) return;
    // Seguro: si la animación no llega a dispararse, mostramos todo igualmente.
    setTimeout(function () { els.forEach(function (e) { e.classList.add('nq-visible'); }); }, 2500);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('nq-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('nq-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e, i) { e.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(e); });
  }

  function initGallery() {
    document.querySelectorAll('[data-nq-gallery]').forEach(function (gal) {
      var main = gal.querySelector('[data-nq-main]');
      gal.querySelectorAll('[data-nq-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.style.opacity = 0;
          setTimeout(function () {
            main.src = btn.getAttribute('data-nq-thumb');
            main.srcset = '';
            main.alt = btn.getAttribute('data-nq-alt') || '';
            main.style.opacity = 1;
          }, 150);
          gal.querySelectorAll('[data-nq-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) days--; }
    return d;
  }

  function initDelivery() {
    document.querySelectorAll('[data-nq-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 10;
      var max = parseInt(el.getAttribute('data-max'), 10) || 15;
      var opts = { day: 'numeric', month: 'long' };
      var a = addBusinessDays(new Date(), min).toLocaleDateString('es-MX', opts);
      var b = addBusinessDays(new Date(), max).toLocaleDateString('es-MX', opts);
      var out = el.querySelector('[data-nq-dates]');
      if (out) out.textContent = a + ' y el ' + b;
    });
  }

  function initBuyBox() {
    document.querySelectorAll('[data-nq-buy]').forEach(function (box) {
      var form = box.querySelector('form');
      if (!form) return;
      var priceEl = box.querySelector('[data-nq-price]');
      var wasEl = box.querySelector('[data-nq-was]');
      var saveEl = box.querySelector('[data-nq-save]');
      var stickyPrice = document.querySelector('[data-nq-sticky-price]');
      var packs = box.querySelectorAll('.nq-pack');

      function sync() {
        var checked = box.querySelector('.nq-pack input:checked');
        packs.forEach(function (p) { p.classList.toggle('is-selected', p.contains(checked)); });
        if (!checked) return;
        var lab = checked.closest('.nq-pack');
        if (priceEl) priceEl.textContent = lab.getAttribute('data-price');
        if (stickyPrice) stickyPrice.textContent = lab.getAttribute('data-price');
        if (wasEl) { wasEl.textContent = lab.getAttribute('data-was') || ''; wasEl.style.display = lab.getAttribute('data-was') ? '' : 'none'; }
        if (saveEl) { var s = lab.getAttribute('data-save'); saveEl.textContent = s ? '-' + s + '%' : ''; saveEl.style.display = s ? '' : 'none'; }
      }
      packs.forEach(function (p) { p.querySelector('input').addEventListener('change', sync); });
      sync();

      var lastBtn = null;
      form.querySelectorAll('button[type=submit]').forEach(function (b) { b.addEventListener('click', function () { lastBtn = b; }); });
      form.addEventListener('submit', function (ev) {
        if (!window.fetch) return;
        ev.preventDefault();
        var goCheckout = lastBtn && lastBtn.hasAttribute('data-nq-checkout');
        var buttons = form.querySelectorAll('button[type=submit]');
        buttons.forEach(function (b) { b.disabled = true; });
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + (goCheckout ? 'checkout' : 'cart');
        }).catch(function () {
          buttons.forEach(function (b) { b.disabled = false; });
          form.submit();
        });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-nq-sticky]');
    var target = document.querySelector('[data-nq-buy] .nq-buy__actions');
    if (!bar || !target) return;
    bar.querySelector('button').addEventListener('click', function () {
      var btn = document.querySelector('[data-nq-buy] [data-nq-checkout]');
      if (btn) btn.click();
    });
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
      });
    }).observe(target);
  }

  function init() { initReveal(); initGallery(); initDelivery(); initBuyBox(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
